import React from "react";

function LoginPage() {
  console.log("hi");
  return <h2>This is the login page</h2>;
}

export default LoginPage;
